const spellsLVL0 = [
  {
    index: "druidcraft",
    name: "Druidcraft",
    url: "/api/spells/druidcraft",
    shortdesc: "You can do a minor nature oriented trick.",
    desc: [
      "Whispering to the spirits of nature, you create one of the following effects within 'range':",
      "You create a tiny, harmless sensory effect that predicts what the weather will be at your location for the next 24 hours. The effect might manifest as a golden orb for clear skies, a cloud for rain, falling snowflakes for snow, and so on. This effect persists for 1 round.",
      "You instantly make a flower bloom, a seed pod open, or a leaf bud bloom.",
      "You create an instantaneous, harmless sensory effect, such as falling leaves, a puff of wind, the sound of a small animal, or the faint order of skunk. The effect must fit in a 5-foot cube.",
      "You instantly light or snuff out a candle, a torch, or a small campfire.",
    ],
    level: 0,
    range: "30 feet",
    components: ["V", "S"],
    duration: "Instantaneous",
    concentration: false,
    casting_time: "1 action",
  },
  {
    index: "guidance",
    name: "Guidance",
    url: "/api/spells/guidance",
    shortdesc: "For up to 1 minute, a target can add 1d4 to one ability check.",
    desc: [
      "You touch one willing creature. Once before the spell ends, the target can roll a d4 and add the number rolled to one ability check of its choice. It can roll the die before or after making the ability check. The spell then ends.",
    ],
    level: 0,
    range: "Touch",
    components: ["V", "S"],
    duration: "Up to 1 minute",
    concentration: true,
    casting_time: "1 action",
  },
  {
    index: "mending",
    name: "Mending",
    url: "/api/spells/mending",
    shortdesc: "Makes minor repairs on an object.",
    desc: [
      "This spell repairs a single break or tear in an object you touch, such as a broken key, a torn cloak, or a leaking wineskin. As long as the break or tear is no longer than 1 foot in any dimension, you mend it, leaving no trace of the former damage.",
      "This spell can physically repair a magic item or construct, but the spell can't restore magic to such an object.",
    ],
    range: "Touch",
    level: 0,
    components: ["V", "S", "M"],
    material: "Two lodestones.",
    duration: "Instantaneous",
    concentration: false,
    casting_time: "1 minute",
  },
  {
    index: "produce-flame",
    name: "Produce Flame",
    url: "/api/spells/produce-flame",
    shortdesc: "Creates a flickering flame in your hand for 10 minutes.",
    desc: [
      "A flickering flame appears in your hand. The flame remains there for the duration and harms neither you nor your equipment. The flame sheds bright light in a 10-foot radius and dim light for an additional 10 feet. The spell ends if you dismiss it as an action or if you cast it again.",
      "You can also attack with the flame, although doing so ends the spell. When you cast this spell, or as an action on a later turn, you can hurl the flame at a creature within 30 feet of you. Make a ranged spell attack. On a hit, the target takes 1d8 fire damage.",
      "This spell's damage increases by 1d8 when you reach 5th level (2d8), 11th level (3d8), and 17th level (4d8).",
    ],
    range: "Self",
    components: ["V", "S"],
    duration: "10 minutes",
    concentration: false,
    casting_time: "1 action",
    level: 0,
    attack_type: "ranged",
    damage: {
      damage_type: {
        index: "fire",
        name: "Fire",
        url: "/api/damage-types/fire",
      },
      damage_at_character_level: {
        lvl2: "1d8",
        lvl4: "1d9",
        lvl5: "2d8",
        lvl11: "3d8",
        lvl17: "4d8",
      },
    },
  },
  {
    index: "resistance",
    name: "Resistance",
    url: "/api/spells/resistance",
    shortdesc:
      "For up to 1 minute, a target can add 1d4 to one saving throw of its choice.",
    desc: [
      "You touch one willing creature. Once before the spell ends, the target can roll a d4 and add the number rolled to one saving throw of its choice. It can roll the die before or after making the saving throw. The spell then ends.",
    ],
    range: "Touch",
    level: 0,
    components: ["V", "S", "M"],
    material: "A miniature cloak.",
    duration: "Up to 1 minute",
    concentration: true,
    casting_time: "1 action",
  },
  {
    index: "shillelagh",
    name: "Shillelagh",
    url: "/api/spells/shillelagh",
    shortdesc: "Change your weapon's damage die and modifier used.",
    desc: [
      "The wood of a club or a quarterstaff you are holding is imbued with nature's power. For the duration, you can use your spellcasting ability instead of Strength for the attack and damage rolls of melee attacks using that weapon, and the weapon's damage die becomes a d8. The weapon also becomes magical, if it isn't already. The spell ends if you cast it again or if you let go of the weapon.",
    ],
    range: "Touch",
    level: 0,
    components: ["V", "S", "M"],
    material: "Mistletoe, a shamrock leaf, and a club or quarterstaff.",
    duration: "1 minute",
    concentration: false,
    casting_time: "1 bonus action",
  },
];

export default spellsLVL0;

/*missing: poison spray - thorn whip*/
